import axios from "axios";

export const updateShippingApi = async (credintial, lang, cookies , shipping_id) => {
  const token = cookies.__t0ken_amar_management;

  let data = JSON.stringify(credintial);

  let config = {
    method: "put",
    url: `${process.env.REACT_APP_API}/update-shipping/${shipping_id}`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
